
import "../About/Aboutus.css";
import React from "react";

const OurMissionPreview = ({ previewService, setShowPreviewOurMission }) => {
    const s = previewService;
    if (!s) return null;

    return (
        <div className="mission-overlay" onClick={() => setShowPreviewOurMission(false)}>
            <div className="mission-modal" onClick={(e) => e.stopPropagation()}>

                {/* CLOSE BUTTON */}
                <button className="mission-close" onClick={() => setShowPreviewOurMission(false)}>
                    ✕
                </button>

                <div className="mission-wrapper">

                    {/* TOP SECTION */}
                    <h1 className="mission-top-mini">{s.heading}</h1>

                    <p className="mission-heading">{s.title}</p>

                    <div
                        className="mission-description"
                        dangerouslySetInnerHTML={{ __html: s.description }}
                    />

                    {/* CONTENT SECTION */}
                    <div className="mission-content">

                        {/* LEFT IMAGE */}
                        <div className="mission-left">
                            <img
                                src={s.mission_image}
                                alt="Mission Visual"
                                className="mission-image"
                            />
                        </div>

                        {/* RIGHT 4 CARDS */}
                        <div className="mission-right">
                            {s.missionsData?.map((item, i) => (
                                <div key={i} className="mission-card">
                                    <h4 className="mission-number">{(i + 1).toString().padStart(2, "0")}</h4>

                                    <h3 className="mission-card-title">{item.heading}</h3>

                                    <p
                                        className="mission-card-desc"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    />
                                </div>
                            ))}
                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
};

export default OurMissionPreview;
